import { timeParse } from 'd3'

const debtCoverageBurdenChartData = [
    {
        "dateString": "2010-12-31",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "0.174115857",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2011-06-30",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "0.344050587",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2011-12-31",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2012-06-30",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "0.233839628",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2012-12-31",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "-0.027902477",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2013-06-30",
        "debt_over_ebit_deviation": "",
        "debt_over_ebit_h_deviation": "0.161715681",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2013-12-31",
        "debt_over_ebit_deviation": "-2.156011585",
        "debt_over_ebit_h_deviation": "-0.092679945",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2014-06-30",
        "debt_over_ebit_deviation": "-0.913809233",
        "debt_over_ebit_h_deviation": "-0.150584335",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2014-12-31",
        "debt_over_ebit_deviation": "-1.262180302",
        "debt_over_ebit_h_deviation": "-0.222770293",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2015-06-30",
        "debt_over_ebit_deviation": "-0.526271771",
        "debt_over_ebit_h_deviation": "-0.236265269",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2015-12-31",
        "debt_over_ebit_deviation": "0.317113766",
        "debt_over_ebit_h_deviation": "0.035375923",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2016-06-30",
        "debt_over_ebit_deviation": "2.083161922",
        "debt_over_ebit_h_deviation": "0.147631197",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2016-12-31",
        "debt_over_ebit_deviation": "1.168956683",
        "debt_over_ebit_h_deviation": "-0.133475297",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2017-06-30",
        "debt_over_ebit_deviation": "1.575869673",
        "debt_over_ebit_h_deviation": "-0.112361021",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2017-12-31",
        "debt_over_ebit_deviation": "0.364460754",
        "debt_over_ebit_h_deviation": "0.031825341",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2018-06-30",
        "debt_over_ebit_deviation": "0.323619126",
        "debt_over_ebit_h_deviation": "0.25491294",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2018-12-31",
        "debt_over_ebit_deviation": "-0.25848758",
        "debt_over_ebit_h_deviation": "-0.018999229",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2019-06-30",
        "debt_over_ebit_deviation": "0.232588149",
        "debt_over_ebit_h_deviation": "-0.098226998",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2019-12-31",
        "debt_over_ebit_deviation": "-0.171730451",
        "debt_over_ebit_h_deviation": "-0.111821558",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    },
    {
        "dateString": "2020-06-30",
        "debt_over_ebit_deviation": "11.36889793",
        "debt_over_ebit_h_deviation": "0.371496261",
        "chart_name": "Debt Coverage Burden (Net Debt / EBIT)",
        "chart_number": "3"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default debtCoverageBurdenChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
